import { erpAxios } from '.';

const getTipDokumenta = async () => {
  const { data } = await erpAxios.get('/gr-tip-dokumenta');
  return data;
};

export default getTipDokumenta;
